<template>
    <div class="drop-shadow-sm bg-white rounded-sm p-2">
        <div class="w-full overflow-hidden rounded-full bg-gray-300 passmeter-h">
            <div class="passmeter-h" v-bind:class="[ color ]" v-bind:style="{ width: getPercentage() }"></div>
        </div>
        <div class="text-xs flex flex-row px-1 mt-1">
            <div class="flex-grow text-gray-500" v-text="message"></div>
            <div class="text-gray-500" v-text="getPercentage()"></div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "v-passmeter",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            length: 0,
            password: '',
            percentage: 0,
            color: 'bg-red-400',
            message: 'Poor',
        }
    },
    methods: {
        getPercentage() {
            return this.percentage + '%';
        },
    },
    watch: {
        value(n : any) {
            this.password = n;
            this.length = n.length;

            let score = 0,
                bonus = ['*', '@', '0', 'x', 'y', 'z', 'X', 'Y', 'Z','q', 'Q'],
                nums = (n.match(/\d/g) || []).length,
                uppr = n.replace(/[^A-Z]/g, '').length,
                lowr = n.replace(/[^a-z]/g, '').length,
                lttr = uppr + lowr,
                char = this.length - (lttr + nums);

            score += this.length;
            score += (nums * 3);
            score += (uppr * 4);
            score += (char * 4);
            score += (lowr * 1);

            if(nums >= 2)
            {
                score += 5;
            }

            if(uppr >= 2)
            {
                score += 8;
            }

            if(lowr >= 2)
            {
                score += 3;
            }

            if(uppr > lowr)
            {
                score += 5;
            }

            if(lttr >= 5)
            {
                score += 3;
            }

            if(lttr > nums)
            {
                score += 5;
            }

            if(char >= 2)
            {
                score += 5;
            }
            else if(char >= 5)
            {
                score += 8;
            }

            if(this.length >= 8)
            {
                score += 8;
            }

            if(this.length >= 10)
            {
                score += 5;
            }

            if(this.length >= 15)
            {
                score += 5;
            }

            if(this.length >= 20)
            {
                score += 8;
            }

            if(this.length >= 24)
            {
                score += 10;
            }

            if(this.length >= 28)
            {
                score += 12;
            }

            bonus.forEach(function(i : any) {
                if(n.includes(i))
                {
                    score += 3;
                }
            });

            if(score > 100)
            {
                score = 100;
            }

            this.percentage = Math.round((score / 100) * 100);
            this.$emit('score', this.percentage);
        },
        percentage(val : any) {
            if(val < 30)
            {
                this.message = 'Very Poor';
                this.color = 'bg-red-400';
            }
            else if(val >= 30 && val < 50)
            {
                this.message = 'Poor';
                this.color = 'bg-yellow-400';
            }
            else if(val >= 50 && val < 70)
            {
                this.message = 'Good';
                this.color = 'bg-green-400';
            }
            else if(val >= 70 && val < 100)
            {
                this.message = 'Very Good';
                this.color = 'bg-green-600';
            }
        }
    },
})
</script>

<style scoped>
.passmeter-h {
    height: 10px;
}
</style>